
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/womens-community-group",
      function () {
        return require("private-next-pages/womens-community-group/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/womens-community-group"])
      });
    }
  